import classNames from 'classnames';

import { FormControl, FormControlLabel } from '@mui/material';
import MUICheckbox from '@mui/material/Checkbox';
import { colors } from 'styles/colors';

import { Form } from '@portal/ui-library';
import { CheckboxProps } from '@portal/ui-library/dist/components/Checkbox/Checkbox';
import { useId } from 'react';

const { Field } = Form.Components;

type DisclaimerCheckboxProps = {
  componentKey: string;
  onChange?: (value: boolean) => void;
} & CheckboxProps;

export const DisclaimerCheckbox = ({
  className = '',
  componentKey,
  description = '',
  disabled,
  onChange
}: DisclaimerCheckboxProps) => {
  const {
    onChange: formOnChange,
    hasError,
    message,
    value,
    isDirty,
    setIsDirty
  } = Form.hooks.useFormComponent(componentKey);
  const id = useId();
  const handleOnChange = () => {
    setIsDirty();
    onChange?.(!value);
    formOnChange(!value);
  };

  const isError = hasError && isDirty;
  const fieldId = `${id}-field`;
  return (
    <Field id={fieldId} error={isError} message={message} className="p-0">
      <div
        className={classNames(
          'flex items-start justify-start gap-x-[24px] rounded-[8px] p-[24px]',
          className,
          value ? 'bg-primary-20' : 'bg-surface-60'
        )}
      >
        <div>
          <FormControl error={isError} disabled={disabled}>
            <FormControlLabel
              className={className}
              data-testid="checkbox-label"
              checked={!!value}
              onChange={handleOnChange}
              control={
                <MUICheckbox
                  checked={!!value}
                  onChange={handleOnChange}
                  inputProps={{
                    'aria-invalid': isError,
                    'aria-describedby': isError ? fieldId : undefined
                  }}
                  sx={
                    isError
                      ? {
                          color: colors.danger[60],
                          '&.Mui-checked': {
                            color: colors.danger[60]
                          }
                        }
                      : {}
                  }
                  data-testid="checkbox-icon"
                />
              }
              label={description}
            />
          </FormControl>
        </div>
      </div>
    </Field>
  );
};
